import React from 'react';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {TTypeConstructor, TTypeApplication} from '@packages/systems/wfdl-ast';
import {extraAtomFields} from '@packages/shared/constants/Atoms';

export const formFileUploadInputDefaults = {
  attr: {
    multiple: false,
    required: false,
    type: 'file',
  },
  form: {
    acceptCustom: false,
    acceptDocuments: false,
    acceptImages: false,
    customTypes: '',
    manageTypes: false,
    type: 'file-upload-input',
  },
} as const;

const FormFileUploadInput = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    const formFileUploadClasses = classes.push('w-file-upload-input');
    return <input {...generateAttributes(attributes, formFileUploadClasses)} />;
  }
);

const config = Atom.create({
  displayName: 'Input',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  showEmpty: false,
  render: FormFileUploadInput,
  dataType: TTypeApplication({
    con: TTypeConstructor(
      qualify(Plugins.name('Form'), typeName('FormFileUpload'))
    ),
    arg: extraAtomFields,
  }),
  hideAncestorSettings: true,
});

export default config;
